import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

export default function Login() {
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn, user, profile, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (authLoading) return;
    if (user && profile) {
      navigate(profile.role === 'admin' ? '/admin' : '/inventory');
    }
  }, [user, profile, authLoading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { error } = await signIn(loginId, password);
      if (error) throw error;
      toast.success('Berhasil masuk');
    } catch (error) {
      toast.error(error.message || 'Autentikasi gagal');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-10"
        style={{
          backgroundImage: 'url(https://images.pexels.com/photos/16100082/pexels-photo-16100082.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)'
        }}
      />

      <div className="relative z-10 w-full max-w-md p-8">
        <div className="bg-white border border-zinc-300 rounded-2xl p-8 shadow-lg">
          <div className="flex items-center gap-3 mb-2">
            <img
              src="https://customer-assets.emergentagent.com/job_fleet-tire-hub/artifacts/v5lfjoov_Logo%20GTB.svg"
              alt="GTB"
              className="h-10 w-auto"
            />
            <h1 className="text-2xl sm:text-3xl font-black uppercase tracking-widest text-zinc-900" style={{ fontFamily: 'Chivo' }}>
              GTB TIRE
            </h1>
          </div>
          <p className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 mb-8">SISTEM OPERASI ARMADA</p>

          <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form">
            <div>
              <label className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 block mb-2">ID Perusahaan</label>
              <input
                type="text"
                value={loginId}
                onChange={(e) => setLoginId(e.target.value)}
                placeholder="contoh: GTB01 atau admin"
                autoComplete="username"
                className="w-full bg-white border border-zinc-300 rounded-lg p-3 text-zinc-900 font-mono focus:border-red-500 focus:ring-1 focus:ring-red-500 focus:outline-none"
                required
                data-testid="login-id-input"
              />
            </div>

            <div>
              <label className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 block mb-2">Kata Sandi</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                className="w-full bg-white border border-zinc-300 rounded-lg p-3 text-zinc-900 font-mono focus:border-red-500 focus:ring-1 focus:ring-red-500 focus:outline-none"
                required
                data-testid="password-input"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-red-600 hover:bg-red-700 text-white font-mono uppercase text-xs tracking-wider py-3 px-6 rounded-lg shadow-sm transition-colors disabled:opacity-50"
              data-testid="submit-button"
            >
              {loading ? 'MEMPROSES...' : 'MASUK'}
            </button>
          </form>

          <p className="mt-6 text-center text-[11px] font-mono text-zinc-500 leading-relaxed">
            Lupa password atau belum punya akun?<br/>
            <span className="text-zinc-700">Hubungi administrator GTB.</span>
          </p>
        </div>
      </div>
    </div>
  );
}
